import { v4 as uuidv4 } from "uuid";
import * as types from "./types";
import * as pageTypes from "../page/types";

// Generates a fresh idempotency key automatically when the checkout page
// loads (config fetch succeeds). The key remains stable for the lifetime of
// that page load — accidental double-clicks and transport retries all reuse
// it, so the server's dedupe catches them.
//
// We deliberately do NOT rotate on PLACE_ORDER_SUCCESS: rotating immediately
// after a success would create a window where a stale double-click (fired
// after the success dispatch but before navigation away) reads the new key
// and bypasses dedup, producing a real duplicate order. Page navigation
// after success triggers a fresh FETCH_CHECKOUT_CONFIGURATIONS_SUCCESS on
// the next page mount, which is when we want a new key.
const idempotencyKeyReducer = (state = "", action: any) => {
  switch (action.type) {
    case pageTypes.FETCH_CHECKOUT_CONFIGURATIONS_SUCCESS:
      return uuidv4();
    case types.SET_IDEMPOTENCY_KEY:
      return action.payload ?? "";
    case types.CLEAR_IDEMPOTENCY_KEY:
      return "";
    default:
      return state;
  }
};

export default idempotencyKeyReducer;
